<template>
  <section class="pay-success">
    <div class="apply-content page-content">
      <div class="content-wrap">
        <header>
          <p>关注“<span color-primary>ETC助手</span>”公众号并<span color-primary>发送车牌号</span>上传签约资料，否则无法完成设备激活</p>
        </header>
        <div class="imgs">
          <div class="img">
            <img src="../../assets/paySuccess/zhaohang1.png" alt="">
            <p>1.关注“ETC助手”公众号</p>
          </div>
          <div class="img">
            <img src="../../assets/paySuccess/zhaohang2.png" alt="">
            <p>2.发送车牌号</p>
          </div>
          <div class="img">
            <img src="../../assets/paySuccess/zhaohang3.png" alt="">
            <p>3.进小程序输手机号后4位</p>
          </div>
          <div class="img">
            <img src="../../assets/paySuccess/zhaohang4.png" alt="">
            <p>4.按教程完成设备激活</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-bottom">
      <template >
        <button class="copy-btn" cool-btn  @click="copy">复制车牌号</button>
        <button class="cancel-btn" v-if="showCancel" @click="cancelOrder">取消订单</button>
      </template>
    </div>
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// clip
// api
// import ApplyApi from '@/api/apply.api'
import Util from '@/utils/util'

// config
// import ETC from '@/config/etc.config'
// store
import {mapState} from 'vuex'

const PAGE_TITLES = {
  '1': '开通免密',
  '2': '信息绑定',
  'tencent': 'ETC助手',
  'zhaohang': '自助激活'
}

export default {
  name: 'paySuccess',
  mixins: [FunMixin],
  components: {},
  props: {
    plateNo: String,
    orderSn: String
  },
  data() {
    return {
      bgImg: require('../../assets/apply/apply-success-bg.png'),
      isIOS: '',
      showCancel: false
    }
  },
  computed: {
    cardType() {
      return (this.appChannel === 'tencent' || this.appChannel === 'zhaohang') ? this.appChannel : (this.currentCard.card_type)
    },
    ...mapState([
      'currentCard',
      'currentOrder'
    ])
  },
  methods: {
    copy() {
      Util.copy(2342342432 || this.currentOrder.plate_no)
    },
    async cancelOrder() {
      this.m_goPages('cancelOrder')
    }
  },
  mounted() {
    this.m_setPageTitle(PAGE_TITLES[this.cardType || 1])
    if (this.plateNo) {
      this.plateNo = this.plateNo.replace(/ /g, '').toUpperCase()
    } else {
      // this.m_showLoading()
      this.plateNo = this.currentOrder.plate_no.replace(/ /g, '').toUpperCase()
      this.m_loadingClose()
    }
    this.showCancel = this.currentOrder.step_list && !!~this.currentOrder.step_list.can_do.indexOf('CancelOrder') && !(this.appChannel === 'tencent' || this.appChannel === 'zhaohang')
  },
  async created() {
    this.isIOS = await this.m_isIOS()
  }

}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.pay-success{
  text-align: left;
  color: #333333;
  @include routeViewMinH(200px);
  .apply-content {
    padding-bottom: 1px;
  }
  header{
    padding: 30px 40px 40px;
    font-size: 32px;
    font-weight: normal;
    span{
      font-weight: bold;
    }
  }
  .imgs{
    padding: 0 30px;
    @extend %flex-between-wrap;
    .img{
      text-align: center;
      font-size: 24px;
      width: 320px;
      height: 400px;
      position: relative;
      img{
        width: 320px;
        height: 306px;
      }
      p{
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
      }
    }
  }
  .input{
    margin: 60px auto 40px;
    width: 400px;
    height: 90px;
    line-height: 90px;
    border: 1px solid #cccccc;
    border-radius: 10px;
    text-align: center;
    font-size: 40px;
    color: #666666;
    display: block;
  }
  .apply-bottom{
    padding: 0 55px 30px;
    text-align: center;
    .tip{
      font-size: 24px;
      color: #999999;
      line-height: 34px;
    }
    button{
      margin-top: 30px;
    }
    .cancel-btn{
      color: #999999;
      font-size: 24px;
      height: 30px;
      line-height: 30px;
      padding: 10px;
      margin-top: 20px;
      box-sizing: content-box;
    }
  }
}
</style>
